import { Flex } from '#atoms';
import { Gym as TGym } from '#types/gyms';
import styled from 'styled-components';

type GymProps = {
  gym: TGym;
  onClick?: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

export default function Gym({ gym, onClick, ...props }: GymProps) {
  return (
    <Wrapper direction="column" onClick={onClick} {...props}>
      <Title>{gym.name}</Title>
      <Address>{gym.address}</Address>
    </Wrapper>
  );
}

const Wrapper = styled(Flex)`
  cursor: pointer;
`;

const Title = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray15};
`;

const Address = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.gray100};
`;
